import ContractABI from "../jsons/ContractABI.json";

export const CONTRACT_ADDRESS = "0x7C1b2aceF24cA33570A876289CC00722C51381ee";
export const CONTRACT_ABI = ContractABI.abi;